module.exports = __webpack_public_path__ + "img/Porto Apartment - 71 of 85.dd40b4eb.jpeg";